import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-email-preview',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.scss']
})
export class EmailPreviewComponent implements OnInit {
	public emailHtml: SafeHtml;
	public loading: boolean = true;
	public error: boolean = false;
	private campaignID: string;
	private employerID: string;

	constructor(
		private route: ActivatedRoute, 
		private dataService: DataService,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		this.campaignID = this.route.snapshot.paramMap.get("campaignID");
		this.employerID = this.route.snapshot.paramMap.get("employerID");
		
		if (this.campaignID && this.employerID) {
			this.loadEmailHtml();
		} else {
			this.error = true;
			this.loading = false;
		}
	}

	private loadEmailHtml(): void {
		this.dataService.getEmailHtml(this.campaignID, this.employerID).subscribe({
			next: (html) => {
				this.emailHtml = this.sanitizer.bypassSecurityTrustHtml(html);
				this.loading = false;
			},
			error: (err) => {
				console.error('Error loading email HTML:', err);
				this.error = true;
				this.loading = false;
			}
		});
	}
}
